<template>
	<div>
		<el-tabs v-model="tabName">

			<el-tab-pane label="កំណត់ផ្ទាំងផ្សាយពាណិជ្ជកម្ម" name="first"></el-tab-pane>
			<el-tab-pane label="កំណត់ប្រភេទកញ្ចប់ឥវ៉ាន់" name="second"></el-tab-pane>
			<el-tab-pane label="ការកំណត់តម្លៃ" name="third"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first'">
			<md-table>
				<md-table-row>
					<md-table-head>ល.រ.</md-table-head>
					<md-table-head>រូបភាព</md-table-head>
					<md-table-head>កាលបរិច្ឆេទ</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>
				<md-table-row v-for="(slide, index) in slideList">
					<md-table-cell>{{index + 1}}</md-table-cell>
					<md-table-cell><img :src="config.cdn + '/images/' + slide.image_url"
							style="width: 150px" /></md-table-cell>
					<md-table-cell>{{config.datelify(slide.created_date)}}</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-danger" @click="deleteSlide(slide.hash)">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">លុបចេញ</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
			<div style="width:100%; text-align: right; display: flex; justify-content: right;">
				<div style="text-align: center; width: 250px">
					<p>បន្ថែមផ្ទាំងថ្មី 800 x 550px</p>
					<input type="file" ref="image_slide" accept="image/*" style="display: none;"
						@change="uploadImage($event)">
					<img class="thumb-profile" :src="config.getProfileUrl()" v-if="slide.image_url.length == 0">
					<img class="thumb-profile" :src="config.cdn + '/images/' + slide.image_url" v-if="slide.image_url.length > 0">
					<md-button class="md-primary" @click="openSlide()" v-if="slide.image_url.length == 0">បញ្ចូលរូបភាព</md-button>
					<template v-else>
						<md-button class="md-danger" @click="removeSlide()">លុបចោល</md-button>
						<md-button class="md-success" @click="postSlide()">បង្កើត</md-button>
					</template>
				</div>
			</div>

		</div>
		<div v-if="tabName == 'third'">
			<md-table>
				<md-table-row>
					<!-- <md-table-head>n.o</md-table-head> -->
					<md-table-head>ឈ្មោះ</md-table-head>
					<md-table-head>តម្លៃ</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>
				<md-table-row v-for="(setting, index) in settingList" v-if="setting_allow.includes(setting.slug)">
					<!-- <md-table-cell>{{index + 1}}</md-table-cell> -->
					<md-table-cell>{{setting.name}}</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="settingList[index].value" :value="settingList[index].value"
								@keyup="">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success" @click="updateSetting(index)">
							<md-icon>done</md-icon>
							<md-tooltip md-direction="top">Update</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</div>
		<div v-if="tabName == 'second'">
			<md-table>
				<md-table-row>
					<md-table-head>ល.រ.</md-table-head>
					<md-table-head>តម្លៃ</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>
				<md-table-row v-for="(package_type, index) in packageTypeList" v-if="package_type.id != 1">
					<md-table-cell>{{index}}</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="packageTypeList[index].name"
								:value="packageTypeList[index].name" @keyup.enter="">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success"
							@click="updatePackageType(index, package_type.id)">
							<md-icon>done</md-icon>
							<md-tooltip md-direction="top">កែប្រែ</md-tooltip>
						</md-button>
						<md-button class="md-just-icon md-simple md-danger" @click="deletePackageType(package_type.id)">
							<md-icon>delete</md-icon>
							<md-tooltip md-direction="top">លុបចេញ</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell>បន្ថែមថ្មី</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="packageType.name" :value="packageType.name"
								@keyup.enter="createPackageType()">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success" @click="createPackageType()">
							<md-icon>done</md-icon>
							<md-tooltip md-direction="top">បន្ថែមថ្មី</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</div>
		<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this ticket ?"
			md-content="By clicking OK this ticket will be deleted from the database and this action can not be undone."
			md-confirm-text="OK" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>

	export default {

		created() {
			this.getSettings();
		},
		data() {
			return {
				isValid: true,
				tabName: 'first',
				slideList: [],
				packageTypeList: [],
				settingList: [],
				setting_allow: ["exchange_rate", "driver_exchange_rate"],
				packageType: {
					name: ""
				},
				slide: {
					image_url: ""
				}
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
					this.packageTypeList = data.body.data.package_type;
					this.settingList = data.body.data.setting;
					this.slideList = data.body.data.slide;
				});
			},
			updateSetting(index) {
				this.$http.post(this.config.api + "/admin/setting/update", {
					slug: this.settingList[index].slug,
					value: this.settingList[index].value
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getSettings();
					}
				})
			},

			updatePackageType(index, package_type_id) {
				this.$http.post(this.config.api + "/admin/setting/package_type/update", {
					package_type_id: package_type_id,
					value: this.packageTypeList[index].name
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ប្រភេទកញ្ចប់ត្រូវបានកែប្រែដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getSettings();
					}
				})
			},
			deletePackageType(package_type_id) {
				this.$http.post(this.config.api + "/admin/setting/package_type/delete", {
					package_type_id: package_type_id
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ប្រភេទកញ្ចប់ត្រូវបានលុបចេញដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getSettings();
					}
				})
			},
			postSlide() {
				if (this.slide.image_url.length == 0) return false;

				this.$http.post(this.config.api + "/admin/setting/slide/post", {
					image_url: this.slide.image_url
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ផ្ទាំងត្រូវបានបង្កើតដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.slide.image_url = "";
						this.getSettings();
					}
				})
			},
			deleteSlide(hash) {
				this.$http.post(this.config.api + "/admin/setting/slide/delete", {
					hash_id: hash
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ផ្ទាំងត្រូវបានលុបដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getSettings();
					}
				})
			},
			uploadImage(e, image) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				let formData = new FormData();

				formData.append("image", files[0], 'imagepro');
				this.$http.post(this.config.api + '/admin/setting/slide/upload', formData).then(res => {
					if (res.body.status == 'success') {
						this.slide.image_url = res.body.data.file_hash;
					}
				})
			},
			openSlide() {
				this.$refs['image_slide'].click();
			},
			removeSlide(id) {
				this.slide.image_url = "";
			},
			createPackageType() {
				this.$http.post(this.config.api + "/admin/setting/package_type/post", {
					name: this.packageType.name
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ប្រភេទកញ្ចប់ត្រូវបានបង្កើតដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.packageType.name = "";
						this.getSettings();
					}
				})
			}

		}
	}
</script>

<style scoped>
	.grid-8 {
		text-align: center;
		max-width: 12.5%;
		min-width: 12.5%;
		flex: 0 0 12.5%;
	}

	.thumb-product {
		width: 100%;
	}

	.product-thumbnail {
		width: 100px;
		height: 100px;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Settings/View.vue